<template>
  <div>
    <el-dialog :modal="false" :visible.sync="showShare" :title="null" :width="isMobile()?'98%':'420'"
               custom-class="share-c" :show-close="false">
      <div class="sharePc">
        <div class="sharePc1" id="target">
          <img src="../assets/css/icon/left_icon.png" class="shareLogo"/>
          <div class="content">
            <span :class="'direct ' + (data.isBuy?'long':'short')">{{data.isBuy==1?$t('long'):$t('short')}}</span>
            <span class="label">｜</span>
            <span class="label" v-if="showLevel">{{data.name=="BTC"?levelBTC:levelETH}}X</span>
            <span class="label">{{data.name}}USD {{$t('contract')}}</span>
          </div>
          <div class="moneyC" :style="{visibility:(winRate?'visible':'hidden')}">
            <span class="moneyRate" v-if="!isHistory" :style="data.pan>0?'color:rgba(46, 189, 133, 1)':'color:rgba(239, 69, 74, 1);'">{{( data.margin==0?0:(parseFloat(data.pan)*100/parseFloat(data.margin)).toFixed(2))}}%</span>
            <span class="moneyRate" v-if="isHistory" :style="profitRate>0?'color:rgba(46, 189, 133, 1)':'color:rgba(239, 69, 74, 1);'">{{profitRate.toFixed(2)}}%</span>
          </div>
          <div class="open" :style="{visibility:(showPrice?'visible':'hidden')}">
            <span class="title">{{$t('open_price')}}</span>
            <span class="value" style="margin-left: 10px">{{isHistory?Number(data.cost).toFixed(2):Number(data.price).toFixed(2)}}</span>
          </div>
          <div class="open" :style="{visibility:(showPrice?'visible':'hidden')}">
            <span class="title">{{isHistory?$t('close_price'):$t('current_price2')}}</span>
            <span class="value" style="margin-left: 10px">{{isHistory?data.price:data.price2}}</span>
          </div>
          <div class="qrC">
            <div class="qrCode">
              <vue-qr class="qrCode" :text="showUrl" :logSrc="require('../assets/imgs/fufuture-1.svg')"
                      :logo-scale="20"/>
            </div>
            <div class="qrTitle">{{ $t("referral_code") }}</div>
            <div class="qrMiddle"></div>
            <div class="qrTitle2">{{ $t('time') }}: {{ now }}</div>
          </div>
        </div>
        <div class="shareNotice">
          <div class="title">{{ $t('select_metric') }}</div>
          <div class="radio-c">
            <el-checkbox v-model="showLevel">{{$t('leverage1')}}</el-checkbox>
            <el-checkbox v-model="winRate">{{$t('return_rate3')}}</el-checkbox>
            <el-checkbox v-model="showPrice">{{$t('price')}}</el-checkbox>
          </div>
        </div>
        <div class="actions">
          <div class="cancel" @click="copy">{{ $t('copy_link') }}</div>
          <div class="download" @click="download">{{ $t('download') }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import html2canvas from "html2canvas";
import {getHistoryData, getTransData} from "../service/queryService";
import {getAccount} from "../utils/wallet";
import {createLeadingContractAndCall} from "../utils/contract";
import {Method, Underling} from "../config/const";
import {BigNumber} from "ethers";
import {isMobile, transBig2number, transNumber2Big, transTime2Date} from "../utils/functions";
import {getLastPrice} from "../service/priceService";

export default {
  components: {
    vueQr
  },
  props: {
    contract: "",
    token: "",
  },

  data() {
    return {
      showShare: false,
      showUrl: "",
      time: "7",
      winRate: true,
      profitRateNumber: "+0",
      winRateNumber: "+0",
      now: "",
      name: "",
      showLevel:true,
      showPrice:true,
      data:{},
      levelBTC:100,
      levelETH:100,
      isHistory:false,
      profitRate:0,
    }
  },
  methods: {
    isMobile,
    show(row,levelBTC,levelETH,isHistory=false) {
      console.log("current row is",row);
      this.showUrl = "https://cf.fufuture.io/#/listPage?contract=" + this.contract + "&token=" + this.token;
      this.showShare = true;
      this.data=row;
      this.levelBTC=levelBTC;
      this.levelETH=levelETH;
      this.isHistory=isHistory;
      this.now = transTime2Date()
      console.log("share will show");
      this.getData();
    },
    hide() {
      this.showShare = false;
    },
    async download() {
      const div = document.getElementById('target');
      const canvas = await html2canvas(div);
      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = 'share.png';
      a.click();
      this.$message.success(this.$t('download_success'))
    },
    async copy() {
      await navigator.clipboard.writeText(this.showUrl);
      await this.$message.success(this.$t('copy_success'))
      this.showShare=false;
    },
    async getData() {
      let profitReturn=this.getHistoryReturnRate(this.data,this.data.name=="BTC"?this.levelBTC:this.levelETH);
      this.profitRate=isNaN(profitReturn)?0:profitReturn;
    },
    getHistoryReturnRate(info,lv){
      let profit=0;

      if(info.direction==1){
        profit= (parseFloat(info.price)-parseFloat(info.cost))*parseFloat(info.amount);
      }else{
        profit= -((parseFloat(info.price)-parseFloat(info.cost))*parseFloat(info.amount));
      }
      //回报率=已实现盈亏/（数量*开仓价格/杠杆倍数*10%）
      console.log("profit is",profit,info.price,info.cost,info.amount,info.direction,(parseFloat(info.price)-parseFloat(info.cost)),parseFloat(info.amount));
      return profit*100/(parseFloat(info.amount)*parseFloat(info.cost)/lv);
    }
  },
  watch: {
    time() {
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>

::v-deep .share-c {
  width: 420px;
  background: transparent !important;
  box-shadow: revert !important;
}


.title-c {
  display: flex;
  align-items: center;

  .title {
    margin-left: 20px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(255, 255, 255, 1);
  }
}

.sharePc {
  width: 420px;
  height: 425px;
  border-radius: 16px;
  background-image: url('../assets/imgs/pc.svg');
  background-size: cover;
  background-position: center; // 居中显示
  background-repeat: no-repeat; // 不重复
  position: relative;

  .close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  &.mobile {
    border-radius: 12px;
    width: 320px;
    height: 568px;
  }

  .sharePc1 {
    background-image: url('../assets/imgs/pc_top.svg');

    &.mobile {
      background-image: url('../assets/imgs/mobile_top.svg');
    }

    background-size: cover;
    background-position: center; // 居中显示
    background-repeat: no-repeat; // 不重复
    border-radius: 16px;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 18px;

    .shareLogo {
      width: 100px;
      height: 27px;
      object-fit: contain;
    }

    .content {
      display: flex;
      gap: 8px;
      margin-top: 22px;
      align-items: center;
      font-weight: 500;

      .img {
        width: 23px;
      }

      .name {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 16.93px;
        color: rgba(234, 236, 239, 1);
      }

      &.mobile {
        margin-top: 44px;
      }

      .direct {
        font-size: 14px;
        color: #C6FE61FF;
      }

      .label {
        font-size: 14px;
        color: #E5E5E5FF;

      }
    }

    .moneyC {
      margin-top: 8px;
      margin-bottom: 5px;
      font-family: gilroy;
      display: flex;
      gap: 48px;

      .title {
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 15.93px;
        color: rgba(229, 229, 229, 1);
      }

      .value {
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 29.02px;
        color: rgba(198, 254, 97, 1);
        margin-top: 4px;
      }
    }

    .open {

      .title {
        font-size: 11px;
        color: #E5E5E5FF;
      }

      .value {
        font-size: 11px;
        color: #C6FE61FF;
      }
    }

    .qrC {
      margin-top: 21px;
      display: grid;
      grid-template-columns: auto auto 1fr auto;
      align-items: end;

      &.mobile {
        grid-template-rows: auto auto;
        grid-template-columns: repeat(2, 1fr); // 三列
      }

      &.mobile {
        margin-top: 66px;
      }

      .qrCode {

        width: 46px;
        height: 46px;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 1px;
        position: relative;

        &.mobile {
          grid-column: 1 / 4;
        }

        .qrCodeSvg {
          width: 44px;
          height: 44px;
        }

        .qrCodeLogo {
          width: 15px;
          height: 15px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background: #FFFFFF;
          padding: 2px;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        }
      }

      .qrTitle {
        font-size: 10px;
        color: #A6A6A6FF;
        margin-left: 10px;

        &.mobile {
          //  grid-column: 1;
          grid-row: 2;
          margin-left: 0px;
          margin-top: 10px;

        }

      }

      .qrTitle2 {
        font-size: 10px;
        color: #A6A6A6FF;
        margin-left: 10px;

        &.mobile {
          //  grid-column: 1;
          grid-row: 2;
          margin-left: 0px;
          margin-top: 10px;
          text-align: right;
        }

      }

      .qrMiddle {
        &.mobile {
          display: none;

        }
      }
    }
  }

  .shareNotice {
    margin-top: 16px;
    font-size: 12px;
    color: #A6A6A6FF;
    margin-left: 24px;

    .title {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 17.38px;
      color: rgba(166, 166, 166, 1);
    }

    .radio-c {
      display: flex;
      margin-top: 12px;

      .el-input__suffix-inner {
        .el-select__caret {
          font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

          &.el-icon-arrow-up::before {
            content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
          }

          &.el-icon-arrow-down::before {
            content: "\e790"; // 和展开时使用同一个图标的 Unicode
          }
        }
      }

      ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
        color: rgba(255, 255, 255, 1) !important;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: white !important;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        background: url('../assets/imgs/radio.svg') no-repeat center;
        border: none;
      }

      ::v-deep .el-radio__inner::after {
        background: transparent;
      }
    }
  }

  .shareButtons {
    margin-top: 13px;
    display: flex;
    margin-left: 24px;
    align-items: center;

    .shareBtnText {
      color: #fff;
      font-weight: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
  }

  .actions {
    display: flex;
    margin-left: 24px;
    margin-right: 24px;
    margin-top: 18px;
    gap: 12px;
    margin-bottom: 20px;

    .cancel {
      height: 34px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      flex: 1;
      border-radius: 6px;
      background: #525252FF;
      cursor: pointer;
    }

    .download {
      cursor: pointer;
      height: 34px;
      flex: 1;
      text-align: center;
      line-height: 34px;
      color: #333333FF;
      font-size: 13px;
      font-weight: 700;
      border-radius: 6px;
      background: #C6FE61FF;
    }
  }
}
.moneyRate{
  font-size: 36px;
}
.long{
  color:rgba(46, 189, 133, 1)
}
.short{
  color:rgba(239, 69, 74, 1);
}


@media (max-width: 750px) {
  .sharePc {
    width: 100%;

    .moneyC {
      gap: 12px !important;
    }
  }

}
</style>
